import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar-page-content" }
const _hoisted_2 = { class: "calendar-page-week-view" }
const _hoisted_3 = { class: "fc-event-main-frame" }
const _hoisted_4 = { class: "fc-event-time" }
const _hoisted_5 = { class: "fc-event-title-container" }
const _hoisted_6 = { class: "fc-event-title fc-sticky" }
const _hoisted_7 = { class: "inline-block overflow-hidden max-w-12rem text-overflow-ellipsis white-space-nowrap" }

import { onMounted, ref, watch } from 'vue';
import FullCalendar from '@fullcalendar/vue3';
import { CalendarOptions, EventClickArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { modifiedRRulePlugin, useDateTime } from '@/composables';
import { EMIT } from '@/enum';
import { useCalendarStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarMonth',
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const calendar = ref();
const calendarStore = useCalendarStore();

__expose({ calendar });

onMounted(() => {
  setCalendarEvents();
});

const setCalendarEvents = () => {
  calendarOptions.value.dayMaxEvents = true;
  calendarOptions.value.events = calendarStore.events || [];
};

watch(() => calendarStore.events, setCalendarEvents);

const calendarOptions = ref<CalendarOptions>({
  plugins: [dayGridPlugin, interactionPlugin, modifiedRRulePlugin, timeGridPlugin],
  initialView: 'dayGridMonth',
  headerToolbar: false,
  dayHeaderFormat: { weekday: 'short' },
  dayMaxEvents: true,
  dayMaxEventRows: true,
  showNonCurrentDates: false,
  views: {
    timeGrid: {
      dayMaxEventRows: 2,
    },
  },
  moreLinkClick: 'popover',
  moreLinkClassNames: 'more-link-popover',
  navLinks: true,
  weekends: true,
  height: '100%',
  events: [],
  eventClick: (info: EventClickArg) => {
    const isDocumented = info.event._def.extendedProps.eventStatus === 'documented';
    const isInPast = (info.event.start as Date) < new Date();
    const isCaseloadManagement = calendarStore.isCaseloadManagement(info.event._def.extendedProps.eventType);
    const showDocumentEvent = isDocumented || isInPast;
    const isCaseloadAndInCurrentMonth =
      isCaseloadManagement && useDateTime().isSameMonthAndYear(info.event.start as Date);

    closeMoreLinkPopover();

    if (showDocumentEvent && !isCaseloadAndInCurrentMonth) {
      emit(EMIT.DOCUMENT_EVENT, info);
    } else {
      emit(EMIT.EDIT_EVENT, info);
    }
  },
  navLinkDayClick: function (date) {
    emit(EMIT.DAY_VIEW, date);
  },
  dateClick: function (info: DateClickArg) {
    emit(EMIT.NEW_EVENT, info);
  },
  viewDidMount: () => emit(EMIT.MOUNTED, 'month'),
});

/**
 * when fullcalendar has 2+ events in creates a popover in MonthView  which needs to close on modal
 */
const closeMoreLinkPopover = () => {
  document.querySelectorAll('.more-link-popover').forEach((link: Element) => {
    if (link.getAttribute('aria-expanded') == 'true') {
      //get controller parent Element
      let parent;
      const control = link.getAttribute('aria-controls');
      if (control) parent = document.getElementById(control);
      if (parent) parent.style.display = 'none';
      //just to be safe reset aria-expanded
      link.setAttribute('aria-expanded', 'false');
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FullCalendar), {
        ref_key: "calendar",
        ref: calendar,
        options: calendarOptions.value
      }, {
        eventContent: _withCtx((arg) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(useDateTime)().formatTimeByTimezone(arg.event.start, arg.event.extendedProps.hostTimezoneName)) + " - " + _toDisplayString(_unref(useDateTime)().formatTimeByTimezone(arg.event.end, arg.event.extendedProps.hostTimezoneName)) + " " + _toDisplayString(arg.event.extendedProps.hostTimezone), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(arg.event.title), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["options"])
    ])
  ]))
}
}

})